<template>
  <div class="terminal-connections mb-3">
    <h3 class="mb-1">{{ $t("settings-payment-terminals") }}</h3>
    <div>
      <el-row
        class="items-row"
        v-for="(t, index) in terminalsConnection"
        :key="index"
      >
        <el-col :span="8" class="d-flex fl-a-c"
          ><p class="item-name">{{ t.terminalId }}</p></el-col
        >
        <el-col :span="5" class="d-flex fl-a-c fl-j-c">
          <p
            v-if="t.connection === TerminalConnectivity.Loading"
            class="d-flex fl-a-c fl-j-c"
          >
            <span class="spinner"></span>
          </p>
          <p
            v-if="t.connection === TerminalConnectivity.Connected"
            class="d-flex fl-a-c fl-j-c"
          >
            <span class="connected-terminal"></span
            ><span class="ml-5">{{ $t("common.connected") }}</span>
          </p>
          <p
            v-if="t.connection === TerminalConnectivity.Disconnected"
            class="d-flex fl-a-c fl-j-c"
          >
            <span class="disconnected-terminal"></span
            ><span class="ml-5">{{ $t("common.not-connected") }}</span>
          </p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

// modules
import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
import {
  getConnectedTerminals,
  TerminalConnectivity,
} from "@/utils/vue-helpers/common";

export default defineComponent({
  name: "TerminalsStatus",
  components: {},
  async setup() {
    const terminalsConnection = ref<
      { terminalId: string; connection: TerminalConnectivity }[] | null
    >([]);
    const groupTerminals = POSConfigModule.groupTerminals;
    for (const t of groupTerminals) {
      terminalsConnection.value?.push({
        terminalId: t,
        connection: TerminalConnectivity.Loading,
      });
    }

    const { t } = useI18n({});

    return {
      terminalsConnection,
      TerminalConnectivity,
      t,
    };
  },
  methods: {
    async checkConnectedTerminals() {
      // Get all connected terminals related to this group from backend
      const connectedTerminals = await getConnectedTerminals();

      if (this.terminalsConnection) {
        for (const t of this.terminalsConnection) {
          if (connectedTerminals.includes(t.terminalId)) {
            // Terminal is connected
            t.connection = TerminalConnectivity.Connected;
          } else {
            // Terminal is disconnected
            t.connection = TerminalConnectivity.Disconnected;
          }
        }
      }
    },
  },
  async mounted() {
    // TODO To be moved to Mounted hook
    // // Lets check connected terminals and show in UI
    await this.checkConnectedTerminals();
  },
});
</script>

<style lang="scss">
@use "@/styles/variables.scss" as *;


.terminal-connections {
  h3 {
    line-height: 22px;
    letter-spacing: 0px;
    font-weight: 700;
    font-style: normal;
    font-size: 18px;
    text-align: left;
  }
  .items-row {
    height: 50px;

    .item-name {
      line-height: 22px;
      letter-spacing: 0px;
      font-weight: 400;
      font-style: normal;
      font-size: 16px;
      text-align: left;
      word-break: keep-all;
    }
  }
  .spinner {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid #ccc;
    border-radius: 50%;
    border-top-color: #333;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .connected-terminal {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid green;
    background-color: green;
    border-radius: 50%;
  }

  .disconnected-terminal {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid red;
    background-color: red;
    border-radius: 50%;
  }
}
</style>
